import { createContext, useContext } from "react";

const PageDataContext = createContext();

const usePageData = () => useContext(PageDataContext);

export { PageDataContext, usePageData };